// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"e0c13ff9","444":"3a060ad4","456":"66bc3710","476":"ccb99251","568":"e5182516","704":"c9da21b7","810":"75b0e4f6","864":"9b387b42","984":"43adb786"}[chunkId] + ".chunk.js";
};